// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__1l6Z-","page":"Pagination_page__1qr66","pages":"Pagination_pages__2GUGj","page--current":"Pagination_page--current__WJQLS"};